import styled from 'styled-components';

import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { fontStyle } from '../../theme/helpers/fontStyle';

export const $LanguageChooserContainer = styled.div`
  min-width: ${spacing(32)};

  [class*='-ValueContainer'] {
    width: 100%;
    padding-right: 0;
    padding-left: 0;
  }
  [class*='-singleValue'] {
    ${fontStyle('sm')};
    font-weight: ${fontWeight('normal')};
  }
  [class*='-control'] {
    border: none;
  }
`;
